const Clock = ({ className }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.4978 19.5C11.0145 19.4996 9.56469 19.0594 8.33162 18.235C7.09854 17.4106 6.13759 16.2391 5.57027 14.8686C5.00295 13.4981 4.85474 11.9902 5.14438 10.5355C5.43402 9.08077 6.1485 7.7446 7.19748 6.69593C8.24647 5.64726 9.58285 4.93316 11.0376 4.64395C12.4924 4.35474 14.0003 4.50339 15.3706 5.07112C16.741 5.63884 17.9122 6.60014 18.7362 7.83346C19.5602 9.06678 20 10.5168 20 12C19.9978 13.9889 19.2066 15.8956 17.8001 17.3017C16.3936 18.7078 14.4866 19.4984 12.4978 19.5ZM12.4978 5.33038C11.1789 5.33082 9.88974 5.72235 8.79332 6.4554C7.6969 7.18845 6.84245 8.23011 6.33801 9.44873C5.83356 10.6674 5.70177 12.0082 5.95931 13.3017C6.21684 14.5952 6.85213 15.7833 7.78485 16.7158C8.71757 17.6483 9.90583 18.2833 11.1994 18.5405C12.493 18.7977 13.8338 18.6656 15.0523 18.1608C16.2708 17.6561 17.3122 16.8014 18.045 15.7048C18.7778 14.6082 19.169 13.3189 19.1691 12C19.1673 10.2314 18.4638 8.53571 17.2131 7.28525C15.9623 6.03479 14.2664 5.3317 12.4978 5.33038Z"
        fill="#666C73"
      />
      <path
        d="M15.5097 12.4153H12.1023V7.34711C12.1023 7.23692 12.1461 7.13127 12.224 7.05336C12.3019 6.97544 12.4076 6.93164 12.5178 6.93164C12.628 6.93164 12.7336 6.97544 12.8115 7.05336C12.8895 7.13127 12.9332 7.23692 12.9332 7.34711V11.5854H15.5097C15.6199 11.5854 15.7255 11.6292 15.8034 11.7071C15.8814 11.7851 15.9251 11.8907 15.9251 12.0009C15.9251 12.1111 15.8814 12.2168 15.8034 12.2947C15.7255 12.3726 15.6199 12.4164 15.5097 12.4164V12.4153Z"
        fill="#666C73"
      />
    </svg>
  );
};

export default Clock;
